import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { AlertController, ModalController } from '@ionic/angular';
import {
    ImageCroppedEvent,
    ImageCropperComponent,
    ImageTransform
} from 'ngx-image-cropper';

@Component({
    selector: 'app-image-cropper',
    templateUrl: './profile-image-cropper.component.html',
    styleUrls: [`./profile-image-cropper.component.scss`]
})
export class ProfileImageCropperComponent {
    @ViewChild('image') public imageElement: ElementRef;
    @ViewChild(ImageCropperComponent) imageCropper: ImageCropperComponent;
    @Input() public imageSource: string;

    public imageDestination: string;
    croppedImage: SafeUrl;
    public outputImageBlob: Blob;
    public transform: ImageTransform = {
        translateUnit: 'px'
    };
    public canvasRotation = 0;
    public translateH = 0;
    public translateV = 0;

    constructor(
        private _modalCtrl: ModalController,
        private _alertCtrl: AlertController,
        private sanitizer: DomSanitizer
    ) {
        this.imageDestination = '';
    }

    public submit(): void {
        this._modalCtrl.dismiss({
            blob: this.outputImageBlob,
            imageUrl: this.croppedImage
        });
    }

    imageCropped(event: ImageCroppedEvent) {
        this.croppedImage = this.sanitizer.bypassSecurityTrustUrl(event.objectUrl);
        this.outputImageBlob = event.blob;
    }

    private flipAfterRotate() {
        const flippedH = this.transform.flipH;
        const flippedV = this.transform.flipV;
        this.transform = {
            ...this.transform,
            flipH: flippedV,
            flipV: flippedH
        };
        this.translateH = 0;
        this.translateV = 0;
    }

    /**
     * rotate image to left 90deg
     */
    public rotateImageLeft(): void {
        this.canvasRotation--;
        this.flipAfterRotate();
    }

    /**
     * rotate image to right 90deg
     */
    public rotateImageRight(): void {
        this.canvasRotation++;
        this.flipAfterRotate();
    }

    public async closeCropper(): Promise<void> {
        const alert = await this._alertCtrl.create({
            header: 'Do you want to save this as the new profile image',
            buttons: [
                {
                    cssClass: 'cancel',
                    role: 'save',
                    text: 'Save'
                },
                {
                    cssClass: 'danger',
                    text: `Don't Save`,
                    role: `delete`
                }
            ]
        });
        await alert.present();
        const res = await alert.onDidDismiss();
        if (res.role === 'delete') {
            this._modalCtrl.dismiss();
        } else {
            this.submit();
        }
    }
}
